// Client-visible feature flags, injected into window by the server at page render
// (see server.js renderRootHtml). Kept tiny + defensive: an un-injected flag
// reads as its safe default.

// CJ 2026-07-29: Monarch's own time clock is retired in favor of Square. When the
// flag is off (the default), clock-in UIs and timecard-edit controls hide; the
// server also rejects those write paths. Managers still review + certify.
export function timeclockEnabled() {
  return typeof window !== 'undefined' && window.__TIMECLOCK_ENABLED === true;
}
